import {Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet} from 'react-native';
import {px} from '../../utils';

const BulletList = ({title, list, style}) => {
  return (
    <Layout style={style}>
      <Text>{title}</Text>
      {list?.map((name, index) => (
        <Text key={index} style={styles.row}>{`${index + 1}. ${name}`}</Text>
      ))}
    </Layout>
  );
};

const styles = StyleSheet.create({
  row: {
    marginTop: px(5),
  },
});

export default BulletList;
